export default __webpack_public_path__ + "static/media/MovieRatingBot.a2713d62.mov";